export function generateOnceOffDTO(dates: string[], timezone: string): any[] {
  return dates.map((dateStr) => {
    const [datePart, timePart] = dateStr.split(', ');
    const [day, month, year] = datePart.split('-');
    const [hour, minute] = timePart.split(':');

    return {
      dayOfWeek: '*',
      second: '*',
      dayOfMonth: day,
      month: month,
      year: year,
      hour: hour,
      minute: minute,
      timezone: timezone,
    };
  });
}
